const regrasAnalise = require('@/utils/' +
  process.env.ESTADO +
  '/regrasAnalise').default

export default [
  {
    nome: 'Caixa de Entrada',
    icon: 'envelope',
    permissao: 'VIEW_CAIXA_DE_ENTRADA',
    routeName: 'CAIXA_ENTRADA'
  },
  {
    nome: 'Caixa de Entrada',
    icon: 'envelope',
    permissao: 'VIEW_CAIXA_DE_ENTRADA_UC',
    routeName: 'CAIXA_ENTRADA_UC'
  },
  {
    nome: 'Caixa de Entrada',
    icon: 'envelope',
    permissao: 'CAIXA_ENTRADA_OS',
    routeName: 'CAIXA_ENTRADA_OS'
  },
  {
    nome: 'Em Análise',
    icon: 'envelope-open',
    permissao: 'VIEW_EM_ANALISE',
    routeName: 'EM_ANALISE'
  },
  {
    nome: 'Cadastros de Georreferenciamento',
    icon: 'map',
    permissao: 'VIEW_CADASTROS_PENDENTES_GEORREFERENCIAMENTO',
    routeName: 'CADASTROS_PENDENTES_GEORREFERENCIAMENTO'
  },
  {
    nome: 'Em Análise',
    icon: 'envelope-open',
    permissao: 'VIEW_EM_ANALISE_UC',
    routeName: 'EM_ANALISE_UC'
  },
  {
    nome: 'Em Análise',
    icon: 'envelope-open',
    permissao: 'VIEW_EM_ANALISE_OS',
    routeName: 'EM_ANALISE_OS'
  },
  {
    nome: 'Aguardando Validação',
    icon: 'clock',
    permissao: 'VIEW_AGUARDANDO_VALIDACAO',
    routeName: 'AGUARDANDO_VALIDACAO_ANALISE'
  },
  {
    nome: 'Aguardando Validação',
    icon: 'clock',
    permissao: 'VIEW_AGUARDANDO_VALIDACAO_UC',
    routeName: 'AGUARDANDO_VALIDACAO_ANALISE_UC'
  },
  {
    nome: 'Emissão de título',
    permissao: 'VIEW_CAIXA_EMISSAO_TITULO',
    icon: 'clock',
    routeName: 'CAIXA_EMISSAO_TITULO'
  },
  {
    nome: 'Análise Coletiva',
    icon: 'file-signature',
    permissao: 'VIEW_ANALISE_CONJUNTA',
    routeName: 'ANALISE_COLETIVA'
  },
  {
    nome: 'Emissão de Custas',
    icon: 'hand-holding-usd',
    permissao: 'VIEW_EMISSAO_CUSTAS_CERTIDAO',
    routeName: 'EMISSAO_CUSTAS_CERTIDAO'
  },
  {
    nome: 'Aguardando Cálculo das custas',
    icon: 'hand-holding-usd',
    permissao: 'VIEW_CAIXA_CUSTAS',
    routeName: 'AGUARDANDO_CALCULO_CUSTAS'
  },
  {
    nome: 'Aguardando OS',
    icon: 'hourglass-start',
    permissao: 'VIEW_CAIXA_AGUARDANDO_OS',
    routeName: 'AGUARDANDO_OS'
  },
  {
    nome: process.env.ESTADO === 'ma' ? 'Boleto' : 'DAE',
    icon: 'dollar-sign',
    permissao: 'VIEW_DAES',
    routeName: 'DAE'
  },
  {
    nome: regrasAnalise.messages.menuTituloCertidao,
    icon: 'award',
    permissao: 'VIEW_TITULO_CERTIDAO',
    routeName: 'TITULO_CERTIDAO'
  },
  {
    nome: 'Títulos para Entrega',
    permissao: 'VIEW_TITULOS_PARA_ENTREGA',
    icon: 'map',
    routeName: 'TITULOS_PARA_ENTREGA'
  },
  {
    nome: 'Processos Arquivados',
    icon: 'hdd',
    permissao: 'VIEW_PROCESSOS_ARQUIVADOS',
    routeName: 'PROCESSO_ARQUIVADO'
  },
  {
    nome: 'Processos Finalizados',
    icon: 'hdd',
    permissao: 'VIEW_PROCESSOS_ARQUIVADOS_UC',
    routeName: 'FINALIZADOS_UC'
  },
  {
    nome: 'Arquivado pela GAC',
    icon: 'hdd',
    permissao: 'VIEW_PROCESSOS_ARQUIVADOS_SETOR',
    routeName: 'PROCESSO_ARQUIVADO_GAC'
  },
  {
    nome: 'Processos Arquivados Arrecadacao',
    icon: 'hdd',
    permissao: process.env.ESTADO === 'pa' ? 'VIEW_PROCESSOS_ARQUIVADOS' : '',
    routeName: 'PROCESSO_ARQUIVADO_ARRECADACAO'
  },
  {
    nome: 'Gestão OS REURB',
    icon: 'file-invoice-dollar',
    permissao: 'VIEW_ORDEM_SERVICO_REURB',
    routeName: 'ORDEM_SERVICO_REURB'
  },
  {
    nome: 'Aguardando Atualização da Base',
    icon: 'map',
    permissao: 'VIEW_AGUARDANDO_ATUALIZACAO_BASE',
    routeName: 'ATUALIZACAO_BASE'
  },
  {
    nome: 'Publicação',
    icon: 'tag',
    permissao: 'VIEW_PUBLICACAO',
    routeName: 'PUBLICACAO'
  },
  {
    nome: 'Publicação',
    icon: 'tags',
    permissao: 'VIEW_EDITAL_PUBLICACAO',
    routeName: 'EDITAL_PUBLICACAO'
  },
  {
    nome: 'Aguardando Manifestação',
    icon: 'hourglass-half',
    permissao: 'VIEW_AGUARDANDO_MANIFESTACAO',
    routeName: 'AGUARDANDO_MANIFESTACAO'
  },
  {
    nome: 'Assinaturas',
    icon: 'file-signature',
    permissao: 'VIEW_ASSINATURAS',
    routeName: 'ASSINATURAS'
  },
  {
    nome: 'Processos Finalizados',
    icon: 'bookmark',
    permissao: 'VIEW_PROCESSOS_FINALIZADOS',
    routeName: 'PROCESSO_FINALIZADO'
  },
  {
    nome: 'Avocar Processos',
    icon: 'file-alt',
    permissao: 'AVOCAR_PROCESSO',
    routeName: 'AVOCAR_PROCESSO'
  },
  {
    nome: 'Documentos',
    icon: 'file-alt',
    permissao: 'VIEW_DOCUMENTOS',
    routeName: 'DOCUMENTOS'
  },
  {
    nome: 'Arquivos',
    icon: 'box-open',
    permissao: 'VIEW_ARQUIVOS',
    routeName: 'ARQUIVOS'
  },
  {
    nome: 'Processos Assinados',
    icon: 'file-signature',
    permissao: 'VIEW_PROCESSOS_ASSINADOS',
    routeName: 'PROCESSOS_ASSINADOS'
  },
  {
    nome: 'Processos em Retificação',
    permissao: 'VIEW_PROCESSOS_RETIFICACAO',
    icon: 'pen-square',
    routeName: 'CAIXA_RETIFICACAO'
  },
  {
    nome: 'Informações Solicitadas',
    icon: 'info-circle',
    permissao: 'INFORMACAO_SOLICITADA',
    routeName: 'INFORMACAO_SOLICITADA'
  },
  {
    nome: 'Portarias Aguardando Emissão',
    icon: 'balance-scale',
    permissao: 'VIEW_PORTARIAS',
    routeName: 'CAIXA_PORTARIA'
  },
  {
    nome: 'Portarias Em Emissão',
    icon: 'balance-scale',
    permissao: 'VIEW_PORTARIAS',
    routeName: 'CAIXA_PORTARIA_EMISSAO'
  },
  {
    nome: 'Portarias Aguardando Validação',
    icon: 'balance-scale',
    permissao: 'VALIDAR_PORTARIA',
    routeName: 'CAIXA_PORTARIA_VALIDACAO'
  },
  {
    nome: 'Caixa de Entrada',
    icon: 'file-alt',
    permissao: 'VIEW_PROCESSOS_VTN',
    routeName: 'CAIXA_AGUARDANDO_VTN'
  },
  {
    nome: 'Aguardando envio ao Cartório',
    icon: 'file-alt',
    permissao: 'VIEW_CAIXA_ENVIO_CARTORIO',
    routeName: 'AGUARDANDO_ENVIO_CARTORIO'
  },
  {
    nome: 'Aguardando registro em Cartório',
    icon: 'file-alt',
    permissao: 'VIEW_CAIXA_ENVIO_REGISTRO_CARTORIO',
    routeName: 'AGUARDANDO_ENVIO_REGISTRO_CARTORIO'
  },
  {
    nome: 'Caixa de entrada Arrecadação',
    icon: 'envelope',
    permissao: 'CAF_CAIXA_DE_ENTRADA',
    routeName: 'CAF_CAIXA_DE_ENTRADA'
  },
  {
    nome: 'Caixa de entrada Arrecadação',
    icon: 'envelope',
    permissao: 'GP_CAIXA_DE_ENTRADA',
    routeName: 'GP_CAIXA_DE_ENTRADA'
  },
  {
    nome: 'Caixa de entrada Arrecadação',
    icon: 'envelope',
    permissao: 'GP_S1_CAIXA_DE_ENTRADA',
    routeName: 'GP_S1_CAIXA_DE_ENTRADA'
  },
  {
    nome: 'Caixa de entrada Arrecadação',
    icon: 'envelope',
    permissao: 'GDA_CAIXA_DE_ENTRADA',
    routeName: 'GDA_CAIXA_DE_ENTRADA'
  },
  {
    nome: 'DAE_VTN',
    icon: 'dollar-sign',
    permissao: 'VIEW_DAES_VTN',
    routeName: 'DAE_VTN'
  },
  {
    nome: 'Processos Analisados',
    icon: 'archive',
    permissao: 'VIEW_PROCESSOS_ANALISADOS',
    routeName: 'PROCESSOS_ANALISADOS'
  },
  {
    nome: 'Configuração de VTN',
    icon: 'file-invoice-dollar',
    permissao: 'VIEW_MENU_CONFIGURACAO_VTN',
    routeName: 'CONFIGURACAO_VTN'
  },
  {
    nome: 'Gestão de VTN',
    icon: 'archive',
    permissao: 'VIEW_MENU_GESTAO_VTN',
    routeName: 'GESTAO_VTN'
  },
  {
    nome: 'Configuração de UPF',
    icon: 'archive',
    permissao: 'VIEW_MENU_CONFIGURACAO_UPF',
    routeName: 'CONFIGURACAO_UPF'
  },
  {
    nome: 'Relatórios de VTN',
    icon: 'archive',
    permissao: 'VIEW_MENU_RELATORIOS_VTN',
    routeName: 'RELATORIOS_VTN'
  },
  {
    nome: 'Aguardando Resposta de Indeferimento',
    icon: 'archive',
    permissao: 'VIEW_MENU_AGUARDANDO_INDEFERIMENTO',
    routeName: 'AGUARDANDO_INDEFERIMENTO'
  },
  {
    nome: 'Solicitar cancelamento de cláusula resolutiva',
    icon: 'file-excel',
    permissao: 'CADASTRAR_LIBERACAO_CLAUSULA',
    routeName: 'analise/liberacao-clausula'
  },
  {
    nome: 'Credenciados',
    icon: 'user',
    permissao: 'VIEW_RELATORIO_GRF_CAF_CREDENCIADOS',
    routeName: 'RELATORIO_GRF_CAF_CREDENCIADOS'
  },
  {
    nome: 'Assinatura Coletiva',
    icon: 'file-signature',
    permissao: 'VIEW_ASSINATURA_CONJUNTA',
    routeName: 'ASSINATURA_CONJUNTA'
  },
  {
    nome: 'Sobrestado',
    permissao: 'VIEW_PROCESSOS_PENDENCIA',
    icon: 'pen-square',
    routeName: 'CAIXA_SOBRESTADO'
  },
  {
    nome: 'Shapes Com Conflito',
    permissao: 'VIEW_CAIXA_CONFLITOS',
    icon: 'map',
    routeName: 'CAIXA_CONFLITOS'
  },
  {
    nome: 'Vistoria Remota',
    permissao: process.env.ESTADO === 'ma' ? '' : 'CAF_CAIXA_DE_ENTRADA',
    icon: 'map',
    routeName: 'CAIXA_VISTORIA_REMOTA'
  },
  {
    nome: 'Cadastros em andamento',
    icon: 'envelope',
    permissao: 'VIEW_CAIXA_CADASTROS_EM_ANDAMENTO',
    routeName: 'CADASTROS_EM_ANDAMENTO_RF'
  },
  {
    nome: 'Cadastros em andamento UC',
    icon: 'envelope',
    permissao: 'VIEW_CAIXA_CADASTROS_EM_ANDAMENTO_UC',
    routeName: 'CADASTROS_EM_ANDAMENTO_UC'
  },
  {
    nome: 'Buscar Processos',
    permissao: 'VIEW_CAIXA_BUSCAR_PROCESSOS',
    icon: 'search',
    routeName: 'BUSCAR_PROCESSOS'
  },
  {
    nome: 'Caixa Solicitações',
    permissao: 'VIEW_CAIXA_SOLICITACOES',
    icon: 'info-circle',
    routeName: 'CAIXA_SOLICITAÇÕES'
  },
  {
    nome: 'Processos Suspensos',
    icon: 'filePause-img',
    permissao: 'VIEW_PROCESSOS_SUSPENSOS',
    routeName: 'VIEW_PROCESSOS_SUSPENSOS'
  }
]



// WEBPACK FOOTER //
// ./src/screens/analise/menu.js